import React, { Fragment, useState } from 'react'
import { TableLine } from '../TableLine/TableLine'
import { getChildrenNumber } from './utils'
import { Props } from './types'
// import styles from './TableLineHandler.module.scss'

function TableLineHandlerComponent<TabType> (props: Props<TabType>) {
  const {
    colKeys,
    row,
    columns,
    paddingLevel = 0,
    onToggleExpand
  } = props

  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(s => !s)
    onToggleExpand && onToggleExpand()
  }

  const renderChild = (child, i) => {
    return (
      <TableLineHandler
        key={i}
        colKeys={colKeys}
        row={child}
        columns={columns}
        paddingLevel={paddingLevel + 1}
      />
    )
  }

  return (
    <Fragment>
      <TableLine
        cells={colKeys.map((key: any) => ({
          ...row[key],
          width: columns[key].width,
          style: row[key].style || columns[key].style,
          numberOfChildren: getChildrenNumber(row.children)
        }))}
        expanded={isExpanded}
        toggleExpand={toggleExpand}
        paddingLevel={paddingLevel}
      />
      {isExpanded && row.children.map(renderChild)}
    </Fragment>
  )
}

const TableLineHandler = TableLineHandlerComponent
export { TableLineHandler }
